import { useState, type FormEvent } from 'react'

interface LoginFormProps {
  onSubmit: (credentials: { username: string; password: string }) => void
  isPending: boolean
  error: string | null
}

export function LoginForm({ onSubmit, isPending, error }: LoginFormProps) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onSubmit({ username: username.trim(), password })
  }

  const canSubmit = username.trim().length > 0 && password.length > 0 && !isPending

  const inputClass =
    'w-full border border-hairline bg-void px-3 py-2.5 text-sm text-ink placeholder:text-faint transition-colors focus:border-bernstein focus:outline-none disabled:opacity-50'

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5" noValidate>
      <div className="flex flex-col gap-2">
        <label htmlFor="username" className="tracked-caps text-[10px] text-muted">
          Benutzername
        </label>
        <input
          id="username"
          name="username"
          type="text"
          autoComplete="username"
          autoFocus
          required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={isPending}
          className={inputClass}
          aria-invalid={error !== null}
        />
      </div>

      <div className="flex flex-col gap-2">
        <label htmlFor="password" className="tracked-caps text-[10px] text-muted">
          Passwort
        </label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={isPending}
          className={inputClass}
          aria-invalid={error !== null}
        />
      </div>

      {error && (
        <p role="alert" className="font-mono text-xs text-loss">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={!canSubmit}
        className="tracked-caps mt-2 bg-bernstein px-6 py-3 text-[11px] text-void transition-colors hover:bg-bernstein-dim disabled:cursor-not-allowed disabled:bg-faint disabled:text-void/60"
      >
        {isPending ? 'Wird geprüft' : 'Anmelden'}
      </button>
    </form>
  )
}
